// Single source of truth for lead-capture channels.
// Every WhatsApp/call CTA must go through these so Google Ads
// conversion tracking (gtag_report_conversion) is never missed.

export const PHONE = '+917017353583';
export const PHONE_DISPLAY = '+91 70173 53583';
export const WHATSAPP_NUMBER = '917017353583';

export const waUrl = (message: string): string =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

/** Fires the Google Ads conversion, then lets gtag handle navigation. */
export const reportConversion = (url: string): boolean => {
  if (
    typeof window !== 'undefined' &&
    (window as any).gtag_report_conversion
  ) {
    return (window as any).gtag_report_conversion(url);
  }
  return true;
};

export const waMessages = {
  general: 'Hi JSONPLAY! I have a business idea I want to discuss.',
  website: 'Hi JSONPLAY! I want a website for my business (from ₹12,999).',
  app: 'Hi JSONPLAY! I want a mobile app for my business (from ₹19,999).',
  ai: 'Hi JSONPLAY! I want an AI-powered app (from ₹24,999).',
  quote: 'Hi JSONPLAY! Please send me a free plan and quote for my project.',
};
